import { useState, useEffect, useRef, useCallback } from "react";
import "./EmploymentDetails.css";
import { AgGridReact } from "ag-grid-react";
import { CiUser } from "react-icons/ci";
import { RiEdit2Line } from "react-icons/ri";
import { FiPlus } from "react-icons/fi";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import WidgetsButton from "../../../components/Widgets/button";
import CustomPagination from "../../../components/CustomPagination";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { DialogContentText } from "@mui/material";
import Button from "@mui/material/Button";
import { Form, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import Select, { components } from "react-select";
import makeAnimated from "react-select/animated";
import { useDispatch, useSelector } from "react-redux";
import {
  commonGetData,
  commonSaveData,
  commonGetDataFourth,
  initState,
} from "../../../redux/slices/commonSlice";
import {
  fetchBranchData,
  initBranchState,
} from "../../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../../redux/slices/departmentSlice";

import {
  fetchDesignationList,
  initDesigState,
} from "../../../redux/slices/designationSlice";

import { fetchData, initShiftState } from "../../../redux/slices/shiftsSlice";

import {
  getEmployeeTypeListPath,
  updateEmployementDetailsPath,
  updatePastEmployementDetailsPath,
  getMyBreaksListPath,
  getAttendanceModulePath
} from "../../../services/config";

import { getAttendModule, initAttModule } from "../../../redux/slices/moreSettings";
import { HasPermission } from "../../../services/hasPermission";
import { useNavigate } from "react-router-dom";

const animatedComponents = makeAnimated();

const EmploymentDetails = ({
  user,
  userDetails,
  commonState,
  getUserDetails,
}) => {
  return (
    <div className="body-container">
      <div className="page-body p-0">
        {userDetails.length && (
          <CurrentEmployment
            user={user}
            userDetails={userDetails[0]}
            commonState={commonState}
            getUserDetails={getUserDetails}
          />
        )}
      </div>

      <div className="page-body mt-2">
        {userDetails.length && (
          <PastEmployment
            user={user}
            userDetails={userDetails[0]}
            commonState={commonState}
          />
        )}
      </div>
    </div>
  );
};
const CurrentEmployment = ({
  user,
  userDetails,
  commonState,
  getUserDetails,
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const state = useSelector((state) => state.common);
  const branchState = useSelector((state) => state.branch);
  const departmentState = useSelector((state) => state.department);
  const designationStore = useSelector((state) => state.designation);
  const shiftStore = useSelector((state) => state.shift)
  const attendanceStore = useSelector((state) => state.moreSettings)
  const theneStore = useSelector((state) => state.theme)

  const [empTypeList, setEmpTypeList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [breakList, setBreakList] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [attendanceList, setAttendanceList] = useState([])

  const getEmpList = useCallback(() => {
    dispatch(commonGetData(getEmployeeTypeListPath));
    dispatch(fetchBranchData(user.user_id));
    dispatch(fetchDepartmentData(user.user_id));
    dispatch(fetchDesignationList(user.user_id));
    dispatch(fetchData(user.user_id));
    dispatch(commonGetDataFourth(`${getMyBreaksListPath}${user?.user_id}`));
    dispatch(getAttendModule(`${getAttendanceModulePath}${user.user_id}`));
  }, []);

  useEffect(() => {
    getEmpList();
    if (localStorage.getItem("emp-redirect")) {
      localStorage.removeItem("emp-redirect")
    }
  }, []);

  useEffect(() => {
    if (state.commonGetSuccess) {
      const newArr = state.commonGetData?.map((v) => {
        return { label: v.type_name, value: v.employeeTypeId };
      });
      setEmpTypeList(newArr);
      dispatch(initState());
    }

    if (state.commonGetFourthSuccess) {
      if (
        state.commonGetFourthData &&
        state.commonGetFourthData.length > 0 &&
        Array.isArray(state.commonGetFourthData)
      ) {
        const newArr = state.commonGetFourthData.map((v) => {
          return { label: v.break_name, value: v.breakId };
        });
        const sortArr = newArr.sort((a, b) => (a.value < b.value ? -1 : 1));
        setBreakList(sortArr);
      }
      dispatch(initState());
    }

    if (departmentState.depGetSuccess) {
      const newArr = departmentState.depGetData?.map((v) => {
        return { label: v.department_name, value: v.departmentId };
      });
      setDepartmentList(newArr);
      dispatch(initDepartState());
    }

    if (designationStore.desigSuccess) {
      const newArr = designationStore.desigData?.map((v) => {
        return { label: v.designation_name, value: v.designationId };
      });

      setDesignationList(newArr);
      dispatch(initDesigState());
    }

    if (shiftStore.shiftGetSuccess) {
      setShiftList(shiftStore.shiftGetData);
      dispatch(initShiftState)
    }

    if (attendanceStore.mSetGetAttModSuccess) {
      setAttendanceList(attendanceStore.mSetGetAttModData);
      dispatch(initAttModule());
    }
  }, [state, departmentState, designationStore, shiftStore, attendanceStore, dispatch]);

  useEffect(() => {
    if (branchState.brnGetSuccess) {
      if (
        branchState.brnGetData &&
        branchState.brnGetData.length > 0 &&
        Array.isArray(branchState.brnGetData)
      ) {
        const newArr = branchState.brnGetData.map((v) => {
          return { label: v.branch_name, value: v.branchId };
        });
        const sortArr = newArr.sort((a, b) => (a.value < b.value ? -1 : 1));
        setBranchList(sortArr);
      }
      dispatch(initBranchState());
    }
  }, [branchState, dispatch]);

  const [updateEmployeeDetails, setUpdateEmployeeDetails] = useState({
    staffId: userDetails !== undefined ? userDetails.staffId : "",
    department: userDetails.department,
    employee_type: userDetails.emp_role,
    date_of_joining: userDetails.date_of_join,
    employee_id: userDetails.personalDetails.empId,
    designationId: userDetails.designationId,
    official_email: userDetails.official_email,
    esi_number: userDetails.esi_number,
    pf_number: userDetails.pf_number,
    shiftId: userDetails.employmentDetails.shiftId,
    shiftName: userDetails.employmentDetails.shiftName,
    shiftType: userDetails.employmentDetails.shiftType,
    breakId: userDetails.employmentDetails.breakId,
    breakName: userDetails.employmentDetails.breakName,
    attendanceName: userDetails.employmentDetails.attendanceName,
    attendanceId: userDetails.employmentDetails.attendanceId,

    employmentDetails: userDetails.employementNumber
      ? [
        {
          employementNumber: userDetails.employementNumber,
          companyName: userDetails.companyName,
          designation: userDetails.designation,
          fromDate: userDetails.fromDate,
          toDate: userDetails.toDate,
          companyAddress: userDetails.companyAddress,
        },
      ]
      : [],
  });

  useEffect(() => {
    setUpdateEmployeeDetails((pre) => ({
      ...pre,
      staffId: userDetails !== undefined ? userDetails.staffId : "",
      department: userDetails.department,
      employee_type: userDetails.emp_role,
      date_of_joining: userDetails.date_of_join,
      employee_id: userDetails.personalDetails.empId,
      designationId: userDetails.designationId,
      official_email: userDetails.official_email,
      esi_number: userDetails.esi_number,
      pf_number: userDetails.pf_number,
      shiftId: userDetails.employmentDetails.shiftId,
      shiftName: userDetails.employmentDetails.shiftName,
      shiftType: userDetails.employmentDetails.shiftType,
      breakId: userDetails.employmentDetails.breakId,
      breakName: userDetails.employmentDetails.breakName,
      attendanceName: userDetails.employmentDetails.attendanceName,
      attendanceId: userDetails.employmentDetails.attendanceId,

      employmentDetails: userDetails.employementNumber
        ? [
          {
            employementNumber: userDetails.employementNumber,
            companyName: userDetails.companyName,
            designation: userDetails.designation,
            fromDate: userDetails.fromDate,
            toDate: userDetails.toDate,
            companyAddress: userDetails.companyAddress,
          },
        ]
        : [],
    }))
  }, [userDetails])

  const handelChange = ({ target: { name, value } }) => {
    setUpdateEmployeeDetails((pv) => ({ ...pv, [name]: value }));
  };

  const [saveData, setSaveData] = useState({
    modules: [],
  });

  const [saveBreakData, setSaveBreakData] = useState({
    modules: [],
  });

  const [modulesError, setModulesError] = useState(false);
  const handleBranchChange = (e) => {
    setSaveData({
      ...saveData,
      modules: e,
    });
    setModulesError(false);
  };

  const handleBreakChange = (e) => {
    setSaveBreakData({
      ...saveBreakData,
      modules: e,
    });
    setModulesError(false);
  };

  const [validated, setValidated] = useState(false);

  const handelSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      if (
        saveData.modules.length > 0 ||
        (userDetails.branch != "" &&
          userDetails.branch != null &&
          userDetails.branch != undefined)
      ) {
      } else {
        setModulesError(true);
      }
    } else {
      const data = {
        path: updateEmployementDetailsPath,
        data: {
          userId: user.user_id,
          branch:
            saveData.modules.length > 0
              ? saveData.modules.map((v) => v.value).toString()
              : userDetails.branch,
          staffId: updateEmployeeDetails.staffId,
          department: updateEmployeeDetails.department,
          employee_type: updateEmployeeDetails.employee_type,
          date_of_joining: updateEmployeeDetails.date_of_joining,
          date_of_leaving: "13/10/2024",
          employ: updateEmployeeDetails.employ,
          designationId: updateEmployeeDetails.designationId,
          official_email: updateEmployeeDetails.official_email,
          esi_number: updateEmployeeDetails.esi_number,
          pf_number: updateEmployeeDetails.pf_number,

          shiftId: updateEmployeeDetails.shiftId,
          // breakId: updateEmployeeDetails.breakId,
          breakId: saveBreakData.modules.length > 0
            ? saveBreakData.modules.map((v) => v.value).toString()
            : updateEmployeeDetails.breakId,

          attendanceId: updateEmployeeDetails.attendanceId,
        },
      };

      dispatch(commonSaveData(data));
    }
  };

  useEffect(() => {
    if (commonState.commonError) {
      toast.error(commonState.commonMessage);
      dispatch(initState());
      setOpen(false);
    }
    if (commonState.commonSuccess) {
      getUserDetails();
      toast.success(commonState.commonMessage);
      dispatch(initState());
      setOpen(false);
    }
  }, [commonState.commonSuccess, commonState.commonError]);

  const EmployeeRecords = [
    {
      name: "employee_id",
      label: "Employee Id",
      placeholder: "Enter Employee Id",
    },
    {
      name: "designationId",
      label: "Designation",
      placeholder: "Select Designation",
      isMulti: false,
      chi: designationList,
    },
    {
      name: "branch",
      label: "Branches",
      placeholder: "Enter Branches",
      isMulti: true,
      chi: branchList,
    },
    {
      name: "department",
      label: "Departments",
      placeholder: "Enter Departments",
      chi: departmentList,
    },
    {
      name: "employee_type",
      label: "Employment Type",
      placeholder: "Enter Employee Type",
      chi: empTypeList,
    },

    {
      name: "shiftName",
      label: "Shift Name",
      placeholder: "Enter Shift Name",
    },

    {
      name: "official_email",
      label: "Office Email Id",
      placeholder: "Enter Office Email Id",
    },

    {
      name: "shiftType",
      label: "Shift Type",
      placeholder: "Enter Shift Type",
    },
    { name: "date_of_joining", label: "Date of joining", type: "date" },
    {
      name: "breakName", label: "Break", placeholder: "Select Break"
    },
    { name: "attendanceName", label: "Attendance" },
  ];

  const [scroll, setScroll] = useState("paper");
  const [open, setOpen] = useState(false);

  const preSubmit = () => {
    document.getElementById("submit-form-1").click();
  };

  // const [savedBranch, setSavedBranch] = useState([])
  // const [savedBreak, setSavedBreak] = useState([])

  // const [brnIndex, setBrnIndex] = useState([])
  // const [brkIndex, setBrkIndex] = useState([])

  // useEffect(() => {
  //   if (userDetails.branch) {
  //     const brnData = userDetails.branch.split(",")
  //     setSavedBranch(brnData)
  //     if (brnData) {
  //       const brnIdData = brnData.map((v) => {
  //         return branchList.findIndex((obj) => {
  //           return parseInt(obj.value) === parseInt(v);
  //         });
  //       })
  //       setBrnIndex(brnIdData || [])
  //     }
  //   }
  //   if (updateEmployeeDetails.breakId) {
  //     const brkData = updateEmployeeDetails.breakId.split(",")
  //     setSavedBreak(brkData)
  //     if (brkData) {
  //       const brkIdData = brkData.map((v) => {
  //         return breakList.findIndex((obj) => {
  //           return parseInt(obj.value) === parseInt(v);
  //         });
  //       })
  //       setBrkIndex(brkIdData || [])
  //     }
  //   }
  // }, [userDetails.branch, updateEmployeeDetails.breakId])

  const savedBranch = userDetails.branch ? userDetails.branch.split(",") : [];
  const savedBreak = updateEmployeeDetails.breakId ? updateEmployeeDetails.breakId.split(",") : [];

  const brnIndex =
    savedBranch !== undefined
      ? savedBranch.map((v) => {
        return branchList.findIndex((obj) => {
          return parseInt(obj.value) === parseInt(v);
        });
      })
      : [];

  const brkIndex = savedBreak !== undefined
    ? savedBreak.map((v) => {
      return breakList.findIndex((obj) => {
        return parseInt(obj.value) === parseInt(v);
      });
    })
    : [];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent", // Input ka background
      borderColor: "transparent",
    }),
    menu: (provided) => ({
      ...provided,
      border: "none",
      backgroundColor: theneStore.theme == "dark" ? "#1e1d2e" : "#f8f8facc", // Popup menu background
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? theneStore.theme == "dark" ? "gray" : "#dcd9d9ff" // Hover color
        : state.isSelected
          ? "#90caf9" // Selected color
          : theneStore.theme == "dark" ? "#2e211dff" : "#f8f8facc", // Default
      color: theneStore.theme == "dark" ? "#fff" : "#000",
      cursor: "pointer",
      border: "none",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#d80b0bff", // Selected text color
    }),
  };

  const [isOpenShift, setIsOpenShift] = useState(false)
  const [isOpenBreak, setIsOpenBreak] = useState(false)

  const handleOpenShift = () => {
    localStorage.setItem("emp-redirect", window.location.pathname)
    navigate("/attendance-settings-shifts")
    // setIsOpenShift(true)
  }
  const handleCloseShift = () => {
    setIsOpenShift(false)
  }

  const handleOpenBreak = () => {
    // setIsOpenBreak(true)
    localStorage.setItem("emp-redirect", window.location.pathname)
    navigate("/breaks")
  }
  const handleCloseBreak = () => {
    setIsOpenBreak(false)
  }

  return (
    <div className="">
      <Row>
        <Col sm="12">
          <Widgets
            icon={<WidgetsIcon icon={<CiUser />} title="Employment Details" />}
            button={
              <>
                {/* {
                  HasPermission("Employment Details", "create") && (
                    <WidgetsButton
                      type="button"
                      text="Add Shift"
                      icon={<FiPlus className="btn-icon" />}
                      onClick={handleOpenShift}
                    />
                  )}
                {HasPermission("Employment Details", "create") && (
                  <WidgetsButton
                    type="button"
                    text="Add Break"
                    icon={<FiPlus className="btn-icon" />}
                    onClick={handleOpenBreak}
                  />
                )
                } */}
                {HasPermission("Employment Details", "edit") && (
                  <WidgetsButton
                    type="button"
                    icon={<RiEdit2Line className="btn-icon" />}
                    onClick={() => setOpen(true)}
                  />
                )
                }
              </>
            }
            body={
              <Row className="mt-2">
                {EmployeeRecords.map((item, i) => (
                  <Col sm="6">
                    <div className="flex-space-between">
                      <span className="label-text">{item.label}</span>
                      <span className="value-text">
                        {item.isMulti && item.chi
                          ? brnIndex
                            ?.map((r) => branchList[r]?.label)
                            .filter(Boolean)
                            .join(", ")
                          : !item.isMulti && item.chi
                            ? item.chi.length > 0
                              ? item.chi.map((v, i) => {
                                return updateEmployeeDetails[item.name] ==
                                  v.value
                                  ? v.label
                                  : null;
                              })
                              : null
                            : updateEmployeeDetails[item.name]}
                      </span>
                    </div>
                  </Col>
                ))}
              </Row>
            }
          />
        </Col>
      </Row>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm" // 'xs', 'sm', 'md', 'lg', 'xl'
        fullWidth
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        className="dark-bg-color"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={() => setOpen(false)}>
              X
            </span>
            <span className="title">Employment Details</span>
          </div>
          <button className="universal-btn" onClick={preSubmit}>
            Update Changes
          </button>
        </DialogTitle>

        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            // ref={descriptionElementRef}
            tabIndex={-1}
            style={{ position: "relative" }}
          >
            <Form noValidate validated={validated} onSubmit={handelSubmit}>
              {EmployeeRecords.map((item, i) => {
                return item.name == "shiftType" ||
                  item.name == "shiftName" || item.name == "breakName" || item.name == "attendanceName" ? null : (
                  <Form.Group
                    style={{ width: "100%" }}
                    key={i}
                    className={
                      item.name == "shiftType" || item.name == "shiftName"
                        ? ""
                        : "mt-3"
                    }
                  >
                    <Form.Label className="color-gray">
                      {item.name == "shiftType" || item.name == "shiftName"
                        ? null
                        : item.label}
                      <span style={{ color: "#ec7063" }}>
                        {item.required ? "*" : ""}
                      </span>
                    </Form.Label>
                    {item.isMulti && item.chi ? (
                      <>
                        <br />
                        {branchList.length && (
                          <Select
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            defaultValue={brnIndex?.map((r) => branchList[r])}
                            isMulti
                            placeholder="Select branch"
                            options={branchList}
                            onChange={handleBranchChange}
                            required
                            style={{
                              border: modulesError ? "1px solid #c0392b" : null,
                            }}
                            styles={customStyles}
                            className="universal-input"
                          />
                        )}
                        {modulesError && (
                          <label style={{ color: "#c0392b", fontSize: "14px" }}>
                            Please provide valid {item.label}{" "}
                          </label>
                        )}
                      </>
                    ) : !item.isMulti && item.chi ? (
                      <Form.Select
                        name={item.name}
                        onChange={handelChange}
                        required
                        className="universal-input"
                      >
                        <option value="">Select option</option>
                        {item.chi.length > 0
                          ? item.chi.map((v, i) => {
                            return (
                              <option
                                value={v.value}
                                selected={
                                  updateEmployeeDetails[item.name] == v.value
                                    ? "selected"
                                    : null
                                }
                              >
                                {v.label}
                              </option>
                            );
                          })
                          : null}
                      </Form.Select>
                    ) : item.name == "shiftType" ||
                      item.name == "shiftName" || item.name == "breakName" || item.name == "attendanceName" ? null : (
                      <Form.Control
                        name={item.name}
                        type={item.type}
                        value={updateEmployeeDetails[item.name]}
                        placeholder={item.placeholder}
                        onChange={handelChange}
                        required
                        className="universal-input"
                      />
                    )}
                    <Form.Control.Feedback type="invalid">
                      Please provide valid {item.label}
                    </Form.Control.Feedback>
                  </Form.Group>
                );
              })}

              <Form.Group>
                <Form.Label className="color-gray mt-3">Select Shift</Form.Label>
                <Form.Select
                  name={"shiftId"}
                  onChange={handelChange}
                  required
                  className="universal-input"
                >
                  <option value="">Select Shift</option>
                  {shiftList.length > 0
                    ? shiftList.map((v, i) => {
                      return (
                        <option
                          value={v.shiftId}
                          selected={
                            updateEmployeeDetails["shiftId"] == v.shiftId
                              ? "selected"
                              : null
                          }
                        >
                          {v.shiftName}
                        </option>
                      );
                    })
                    : null}
                </Form.Select>
              </Form.Group>
              {/* Break Dropdown--------- */}
              <Form.Group>
                <Form.Label className="color-gray mt-3">Select Break</Form.Label>
                <Select
                  closeMenuOnSelect={false}
                  components={animatedComponents}
                  defaultValue={brkIndex?.map((r) => breakList[r])}
                  isMulti
                  placeholder="Select break"
                  options={breakList}
                  onChange={handleBreakChange}
                  required
                  style={{
                    border: modulesError ? "1px solid #c0392b" : null,
                  }}
                  styles={customStyles}
                  className="universal-input"
                />
                {/* <Form.Select
                  name={"breakId"}
                  onChange={handelChange}

                  className="universal-input"
                >
                  <option value="">Select Break</option>
                  {breakList.length > 0
                    ? breakList.map((v, i) => {
                      return (
                        <option
                          value={v.breakId}
                          selected={
                            updateEmployeeDetails["breakId"] == v.breakId
                              ? "selected"
                              : null
                          }
                        >
                          {v.break_name}
                        </option>
                      );
                    })
                    : null}
                </Form.Select> */}
              </Form.Group>




              <Form.Group>
                <Form.Label className="color-gray mt-3">Select Attendance</Form.Label>
                <Form.Select
                  name={"attendanceId"}
                  onChange={handelChange}

                  className="universal-input"
                >
                  <option value="">Select Attendance</option>
                  {attendanceList.length > 0
                    ? attendanceList.map((v, i) => {
                      return (
                        <option
                          value={v.attendanceId}
                          selected={
                            updateEmployeeDetails["attendanceId"] == v.attendanceId
                              ? "selected"
                              : null
                          }
                        >
                          {v.moduleName}
                        </option>
                      );
                    })
                    : null}
                </Form.Select>
              </Form.Group>


              <button
                type="submit"
                id="submit-form-1"
                style={{ display: "none" }}
              ></button>
            </Form>
          </DialogContentText>
        </DialogContent>
      </Dialog>


      {/* <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm" // 'xs', 'sm', 'md', 'lg', 'xl'
        fullWidth
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        className="dark-bg-color"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={() => setOpen(false)}>
              X
            </span>
            <span className="title">Shift</span>
          </div>
          <button className="universal-btn" onClick={preSubmit}>
            Update Changes
          </button>
        </DialogTitle>

        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            // ref={descriptionElementRef}
            tabIndex={-1}
            style={{ position: "relative" }}
          >

          </DialogContentText>
        </DialogContent>
      </Dialog> */}
    </div>
  );
};

const PastEmployment = ({ user, userDetails, commonState }) => {
  const dispatch = useDispatch();
  const designationState = useSelector((state) => state.designation);
  const [designationList, setDesignationList] = useState([]);
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getEmpList = useCallback(() => {
    dispatch(fetchDesignationList(user.user_id));
  });

  useEffect(() => {
    getEmpList();
  }, []);

  useEffect(() => {
    if (designationState.desigSuccess) {
      const newArr = designationState.desigData?.map((v) => {
        return { label: v.designation_name, value: v.designationId };
      });
      setDesignationList(newArr);
      dispatch(initDesigState());
    }
  }, [designationState.desigSuccess]);

  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);

  const [pastEmployment, setPastEmployment] = useState({
    userId: user.user_id,
    staffId: userDetails.staffId,
    company_name: "",
    designation: "",
    joining_date: "",
    leaving_date: "",
    currency: "INR",
    salary: "",
    company_gst: "",
  });

  const handleClose = () => {
    setValidated(false);
    setOpen(false);
  };

  const [scroll, setScroll] = useState("paper");

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const descriptionElementRef = useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPastEmployment({
      ...pastEmployment,
      [name]: value,
    });
  };

  const preSubmit = () => {
    document.getElementById("submit-form-2").click();
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      let d = {
        path: updatePastEmployementDetailsPath,
        data: pastEmployment,
      };
      dispatch(commonSaveData(d));
    }
  };

  useEffect(() => {
    dispatch(initState());
    handleClose();
  }, [commonState.commonSuccess]);

  const employmentDetails = userDetails.employmentDetails.employementNumber
    ? [
      {
        employementNumber: userDetails.employmentDetails.employementNumber,
        companyName: userDetails.employmentDetails.companyName,
        designation: userDetails.employmentDetails.designation,
        fromDate: userDetails.employmentDetails.fromDate,
        toDate: userDetails.employmentDetails.toDate,
        companyAddress: userDetails.employmentDetails.companyAddress,
      },
    ]
    : [];

  const columns = [
    {
      headerName: "Employement Number",
      field: "employementNumber",
    },
    {
      headerName: "Company Name",
      field: "companyName",
    },
    {
      headerName: "Designation",
      field: "designation",
    },
    {
      headerName: "From Date",
      field: "fromDate",
    },
    {
      headerName: "To Date",
      field: "toDate",
    },
    {
      headerName: "Company Address",
      field: "companyAddress",
    },
  ];
  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  return (
    <div className="mb-3">
      <Widgets
        icon={<WidgetsIcon icon={<CiUser />} title="Past Employment" />}
        button={
          HasPermission("Employment Details", "create") && (
            <WidgetsButton
              type="button"
              text="Add Past Employment"
              icon={<FiPlus className="btn-icon" />}
              onClick={() => setOpen(true)}
            />
          )
        }
        body={
          <>
            <div
              className="ag-theme-quartz custom-grid mt-3"
              style={{ height: "200px", width: "100%" }}
            >
              <AgGridReact
                rowData={Array.isArray(employmentDetails) ? employmentDetails : []}
                columnDefs={columns}
                omLayout="autoHeight"
                pagination={true}
                paginationPageSize={paginationPageSize}
                onGridReady={onGridReady}
              />
            </div>
            <div className="d-flex align-items-center justify-content-between custom-pagination">
              {gridApi && <CustomPagination gridApi={gridApi} />}
            </div>
          </>
        }
      />

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm" // 'xs', 'sm', 'md', 'lg', 'xl'
        fullWidth
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        className="dark-bg-color"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={() => setOpen(false)}>
              X
            </span>
            <span className="title">Past Employment</span>
          </div>
          <button className="universal-btn" onClick={preSubmit}>
            Update Changes
          </button>
        </DialogTitle>
        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            style={{ position: "relative" }}
          >
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Group>
                <Form.Label className="color-gray">
                  Company Name <span className="error">*</span>
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="company_name"
                  value={pastEmployment.company_name}
                  placeholder="Enter company name"
                  onChange={handleChange}
                  className="universal-input"
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid company name.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label className="color-gray">
                  Designation <span className="error">*</span>
                </Form.Label>
                <Form.Select
                  required
                  type="text"
                  name="designation"
                  value={pastEmployment.designation}
                  placeholder="Enter designation"
                  style={{ color: "gray" }}
                  onChange={handleChange}
                  className="universal-input"
                >
                  <option value="">Select Designation</option>
                  {designationList?.map((row, idx) => {
                    return (
                      <option value={row.value} key={idx}>
                        {row.label}
                      </option>
                    );
                  })}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Please provide a valid designation.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label className="color-gray">
                  Joining Date <span className="error">*</span>
                </Form.Label>
                <Form.Control
                  required
                  type="date"
                  name="joining_date"
                  value={pastEmployment.joining_date}
                  placeholder="Enter joining date"
                  onChange={handleChange}
                  className="universal-input"
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid joining date.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label className="color-gray">
                  Leaving Date <span className="error">*</span>
                </Form.Label>
                <Form.Control
                  required
                  type="date"
                  name="leaving_date"
                  value={pastEmployment.leaving_date}
                  placeholder="Enter leaving date"
                  onChange={handleChange}
                  className="universal-input"
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid leaving date.
                </Form.Control.Feedback>
              </Form.Group>

              <Row className="mt-3">
                <Col sm="4">
                  <Form.Group>
                    <Form.Label className="color-gray">
                      Currency <span className="error">*</span>
                    </Form.Label>
                    <Form.Select
                      required
                      name="currency"
                      value={pastEmployment.currency}
                      onChange={handleChange}
                      className="universal-input"
                    >
                      <option value="">Select Currency</option>
                      <option value="inr" selected>
                        INR
                      </option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      Please select a valid currency type.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col sm="8">
                  <Form.Group>
                    <Form.Label className="color-gray">
                      Salary <span className="error">*</span>
                    </Form.Label>
                    <Form.Control
                      required
                      type="number"
                      name="salary"
                      value={pastEmployment.salary}
                      placeholder="Enter salary"
                      onChange={handleChange}
                      className="universal-input"
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a valid salary.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mt-3 mb-3">
                <Form.Label className="color-gray">
                  Company GST <span className="error">*</span>
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="company_gst"
                  value={pastEmployment.company_gst}
                  placeholder="Enter company GST"
                  onChange={handleChange}
                  className="universal-input"
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid GST.
                </Form.Control.Feedback>
              </Form.Group>
              <Button
                variant="contained"
                color="info"
                type="submit"
                style={{
                  display: "none",
                }}
                id="submit-form-2"
              >
                Save
              </Button>
            </Form>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default EmploymentDetails;
